import React from 'react';
export function PainSection() {
  return;
}